import React, {memo, useCallback, useState,} from "react";
import {Map} from "ol";
import {Button, useToast} from "shared/ui";
import {GeolocationSvg} from "../../../../shared/assets/svgs/GeolocationSvg";
import {useGeolocation} from "@delivus-daas/react-open-layers";
import {GeolocationError} from "ol/Geolocation";

interface Props {
  map?: Map;
}

export const GeolocationButton = memo(({
                                         map
                                       }: Props) => {
  const [isEnableGeolocation, setEnableGeolocation] = useState(false);
  const toast = useToast();
  
  const handleGeoLocationError = useCallback((error: GeolocationError) => {
    toast.error(error.message);
    setEnableGeolocation(false);
  }, [toast]);
  
  useGeolocation(map, isEnableGeolocation, {onError: handleGeoLocationError})
  
  return (<Button
    variant={"primary"}
    size={"sm"}
    className={"button " + isEnableGeolocation}
    onClick={() => setEnableGeolocation((prev) => !prev)}>
    <GeolocationSvg color={isEnableGeolocation ? "white" : "black"} />
  </Button>);
});
